import { POST, GET, msgURL } from '@/http/api.js'

// 公告列表
const getAnnounceList = (params) => POST(msgURL + "/pubinf/publist", params);

export {
    getAnnounceList,
}